/**
 * Inisialisasi widget Chatbaze pada landing page.
 * Memastikan widget tidak dimuat di dalam dashboard atau halaman widget itu sendiri.
 */
export const initChatbazeWidget = () => {
  if (typeof window === "undefined") return;

  // Jangan injeksi jika di dalah iframe atau di route widget/dashboard
  if (window.self !== window.top) return;

  const h = window.location.hash;
  const p = window.location.pathname;
  
  const isDashboard = 
    h.startsWith('#/dashboard') || 
    h.startsWith('#/admin') || 
    p.startsWith('/dashboard') || 
    p.startsWith('/admin');
    
  const isWidget = h.startsWith('#/widget') || p.startsWith('/widget');

  if (isWidget) return;

  // Jangan tampilkan widget utama Chatbaze di halaman Mini Site milik pengguna
  const hostname = window.location.hostname;
  const isCoreDomain = ['chatbaze.id', 'www.chatbaze.id', 'app.chatbaze.id', 'cdn.chatbaze.id', 'embed.chatbaze.id', 'staging.chatbaze.id', 'localhost', '127.0.0.1', 'lvh.me'].includes(hostname) || hostname.includes('ngrok-free.app');
  const isLocalSubdomain = hostname.endsWith('.localhost') || hostname.endsWith('.lvh.me');
  const isLandingPage = !isCoreDomain || isLocalSubdomain;
  if (isLandingPage) return;

  // Hindari duplikasi
  if (document.querySelector('[data-namespace="app"]')) return;

  const s = document.createElement('script');
  s.src = '/embed.js'; 
  s.async = true;
  s.setAttribute('data-license-key', 'LIC-5ZZPA5Q9HM4');
  s.setAttribute('data-namespace', 'app');
  s.setAttribute('data-app-host', window.location.origin);
  
  document.body.appendChild(s);

  // Injeksi style kompatibilitas secara dinamis
  const style = document.createElement('style');
  style.id = 'chatbaze-compat-dynamic';
  style.innerHTML = `[id^="chatbot-widget-iframe"] { pointer-events: auto !important; z-index: 2147483647 !important; }`;
  document.head.appendChild(style);
};
